import { MainWebsiteEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";
import splitTestGroupFeatures from "./splitTestGroupFeatures";
import { getTestGroup } from "../common/util";

export function pageFeature(featureName, onOff) {
  GlamCornerCore.bus.broadcast(MainWebsiteEvents.FeatureFlagUpdated, { featureName, onOff });
  if (onOff === false) {
    return document.querySelector("body").classList.remove("feature-" + featureName);
  } else {
    return document.querySelector("body").classList.add("feature-" + featureName);
  }
}

function getCookies() {
  return document.cookie.split(";").reduce((acc, cookie) => {
    const [key, value] = cookie.split("=");
    acc[key.trim()] = value;
    return acc;
  }, {});
}

function getFeaturesOnOff(testGroupHash) {
  const featuresOnOff = [];
  Object.keys(splitTestGroupFeatures).forEach((feature) => {
    const testBits = splitTestGroupFeatures[feature];
    const testGroup = getTestGroup(testBits, testGroupHash);
    const onOff = testGroup === 0;
    console.log(`${feature} ${onOff}`);
    featuresOnOff.push({ feature, onOff });
  });
  return featuresOnOff;
}

/**
 * @param {{ feature: string, onOff: boolean }[]} featuresOnOff
 */
function enableOrDisablePageFeatures(featuresOnOff) {
  featuresOnOff.forEach(({ feature, onOff }) => {
    pageFeature(feature, onOff);
  });
}

function getPageFeatures() {
  const component = document.querySelector("[data-page-features]");

  if (component) {
    return (component.attributes["data-page-features"].value || "")
      .split(" ")
      .filter((v) => v.length > 0)
      .map((f) => ({ feature: f, onOff: true }));
  } else {
    return [];
  }
}

export function initialisePageFeatures() {
  let didBroadcastTestGroupHash = false;

  function broadcastTestGroupHashFromCookie() {
    if (!didBroadcastTestGroupHash) {
      const cookies = getCookies();
      const testGroupHashOverrideString = cookies["test_group_hash_override"];
      const testGroupHashString = testGroupHashOverrideString || cookies["test_group_hash"];
      if (testGroupHashString !== undefined) {
        const testGroupHash = parseInt(testGroupHashString, 10);
        GlamCornerCore.bus.broadcast("test-group-hash", { testGroupHash });
        didBroadcastTestGroupHash = true;
      }
    }
  }

  // Try broadcast immediately, and again after gcsession xhr is finished.
  // If the cookie is available on page load, we'll broadcast test_group_hash immediately.
  // If it's not available on page load, it will be available after gcsession xhr.
  broadcastTestGroupHashFromCookie();
  GlamCornerCore.bus.on(MainWebsiteEvents.GcSessionXhrFinished, broadcastTestGroupHashFromCookie);

  GlamCornerCore.bus.on("test-group-hash", ({ testGroupHash }) => {
    const testFeatures = getFeaturesOnOff(testGroupHash);
    GlamCornerCore.bus.broadcast("test-features", { testGroupHash, testFeatures });
  });

  return new Promise((resolve) => {
    window.addEventListener("load", () => {
      enableOrDisablePageFeatures(getPageFeatures());

      GlamCornerCore.bus.on("test-features", ({ testGroupHash, testFeatures }) => {
        enableOrDisablePageFeatures(testFeatures);
      });

      resolve();
    });
  });
}
